import { BlockAndInviteActions } from '../shared/BlockAndInviteActions';
import { IProfessionalCardUser } from '../../interfaces';

interface IProfessionalCardActionsProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardActions = ({ user }: IProfessionalCardActionsProps) => (
  <BlockAndInviteActions user={user} source="new_to_you" />
);
